import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import { Descriptions } from 'antd';
import { isEmpty } from '../../util/isEmpty';
// import Spinner from '../common/Spinner';

const CONTACT_NAME = 'contact_name';
const PHONE_NUMBER = 'phone_number';

const BUSINESS_TYPE = 'busines_type';

/**
 * @component
 * @category Form Page
 * @subcategory Delivery
 * @name EcommerceAmazonDescForm
 * @description E-commerce and amazon delivery description form 
 * <br> <br>
 * **Example**
 * ```js
 *   <EcommerceAmazonDescForm isPickupMode={false} descJson={{}} />
 * ```
 */
class EcommerceAmazonDescForm extends Component {
  componentDidMount = () => {
    // this.props.loadJson();
  };
  render() {
    const { descJson, isPickupMode } = this.props;

    // if (!descJson || isEmpty(descJson)) {
    //   return (
    //     <div
    //       style={{ display: 'flex', justifyContent: 'center' }}
    //       className="testR1"
    //     >
    //       <Spinner />
    //     </div>
    //   );
    // }

    let mCountry;
    let city;
    let postal;
    let businessName;
    let email;
    let port = {};
    let address;
    let businessType;
    let contactName;
    let phoneNumber;
    if (descJson) {
      mCountry = descJson.country;
      city = descJson.city;
      postal = descJson.postal;
      businessName = descJson.name;
      email = descJson.email;
      if (descJson.port && !isEmpty(descJson.port)) {
        port = descJson.port;
      }
      address = descJson.address;
      businessType = descJson[BUSINESS_TYPE];

      contactName = descJson[CONTACT_NAME];
      phoneNumber = descJson[PHONE_NUMBER];
    }

    //no. of items in a row depending upon screen size
    const descColumn = { xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 };

    return (
      <>
        <Descriptions
          style={{
            marginTop: '15px',
          }}
          bordered={true}
          size="small"
          // layout="vertical"
          column={descColumn}
        >
          <Descriptions.Item label="Country">{mCountry}</Descriptions.Item>

          <Descriptions.Item label={isPickupMode ? 'Port' : 'Destination city'}>
            {`${port.city}, ${port.country}`}
          </Descriptions.Item>

          <Descriptions.Item label="City">{city}</Descriptions.Item>

          <Descriptions.Item label="Postal">{postal}</Descriptions.Item>

          <Descriptions.Item label="Business Name">
            {businessName}
          </Descriptions.Item>

          <Descriptions.Item label="Business Type">
            {businessType}
          </Descriptions.Item>

          <Descriptions.Item label="Email">{email}</Descriptions.Item>

          <Descriptions.Item label="Contact Name">
            {contactName}
          </Descriptions.Item>

          <Descriptions.Item label="Phone Number">
            {phoneNumber}
          </Descriptions.Item>

          <Descriptions.Item label="Address">{address}</Descriptions.Item>
        </Descriptions>
      </>
    );
  }
}

EcommerceAmazonDescForm.propTypes = {
  /**
   * whether this component is used in pickup section
   */
  isPickupMode: PropTypes.bool,
  /**
   * description json data for the form
   */
  descJson: PropTypes.object,
};

// const mapStateToProps = (state) => {
//   return {
//     ecommerceJson: state.form.delivery.ecommerceJson,
//   };
// };

export default connect(null, actions)(EcommerceAmazonDescForm);
